import type { Ancestor } from "@/entities/ancestor";
import type { ProjectEntity } from "@/entities/project";
import type { AncestorsBreadcrumbItem } from "@/modules/ancestors/ancestors-breadcrumb";

import { TAB_KEYS, TAB_PARAM_KEYS } from "@/constants/TabKeys";

export const getProjectBreadcrumbItems = (project?: ProjectEntity) => {
  if (!project?.ancestors?.length) return [];

  return project.ancestors.map(getProjectBreadcrumbItem);
};

export const getProjectBreadcrumbItem = (
  ancestor: Ancestor
): AncestorsBreadcrumbItem => {
  if (ancestor.type === "organization") {
    return {
      ...ancestor,
      queryParams: `?${TAB_PARAM_KEYS.CONTEXT_TAB_KEY}=${TAB_KEYS.ORGANIZATIONS_PROJECTS}`,
    };
  }

  if (ancestor.type === "location") {
    return {
      ...ancestor,
      queryParams: `?${TAB_PARAM_KEYS.CONTEXT_TAB_KEY}=${TAB_KEYS.LOCATION_PROJECTS}`,
    };
  }

  return ancestor;
};
